"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = require("./animations");
var colors_1 = require("./colors");
require("./fonts");
var shadows_1 = require("./shadows");
var spacing_1 = require("./spacing");
// inputs
exports.input_text = {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 500
};
exports.input_underline_default = { borderBottom: "1px solid " + colors_1.palette['stone-lighter-40'] };
exports.input_underline_focused = { borderBottom: "1px solid " + colors_1.palette['black-base'] };
exports.input_underline_transition = { transition: 'none' };
exports.input_height = { minHeight: 28 };
exports.input_spacing = { padding: 0 };
exports.input = {
    label: {
        color: colors_1.palette['stone-base']
    },
    text: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: 500,
        color: colors_1.palette['black-base']
    },
    underline: {
        default: {
            transition: 'none',
            borderBottom: "1px solid " + colors_1.palette['stone-lighter-40']
        },
        focused: {
            transition: 'none',
            borderBottom: "1px solid " + colors_1.palette['black-base']
        }
    },
    size: {
        minHeight: 28
    },
    spacing: {
        padding: 0
    }
};
// selects
exports.select = {
    options: {
        container: {
            borderRadius: 0,
            boxShadow: shadows_1.shadowLight.subtle
        },
        item: {
            text: {
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontWeight: 500
            },
            default: {
                backgroundColor: 'transparent',
                color: colors_1.palette['black-base']
            },
            focused: {
                backgroundColor: colors_1.palette['turquoise'],
                color: colors_1.palette['white-base']
            },
            selected: {
                backgroundColor: colors_1.palette['turquoise'],
                color: colors_1.palette['white-base']
            },
            multiple: {
                backgroundColor: 'transparent',
                color: colors_1.palette['black-base']
            }
        }
    }
};
// checkboxes
exports.checkbox = {
    default: {
        height: 32,
        width: 32,
        boxSizing: 'border-box',
        borderRadius: 4,
        transition: animations_1.transition
    },
    unchecked: {
        border: "2px solid " + colors_1.palette['grey-base'],
        backgroundColor: colors_1.palette['grey-base']
    },
    checked: {
        border: "2px solid " + colors_1.palette['turquoise'],
        backgroundColor: colors_1.palette['turquoise']
    },
    focused: {
        border: "2px solid " + colors_1.palette['turquoise']
    }
};
// icons
exports.icon = {
    button: {
        backgroundColor: 'transparent',
        color: colors_1.palette['stone-base']
    },
    svg: {
        fill: colors_1.palette['stone-base']
    },
    animation: {
        opacity: 0,
        animation: 'none',
        transform: 'none'
    }
};
// tags
exports.tag = {
    root: {
        height: 24,
        backgroundColor: colors_1.palette['black-base'],
        margin: '0px 16px 2px 0px'
    },
    svg: {
        fill: colors_1.palette['black-base'],
        width: 12,
        height: 12,
        padding: '2px'
    },
    label: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: 400,
        color: colors_1.palette['white-base']
    },
    delete: {
        width: '12px',
        height: '12px',
        margin: '0 4px 0 4px'
    }
};
// toggles
exports.toggle = {
    label: {
        container: {
            display: 'flex',
            alignItems: 'center'
        }
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        width: spacing_1.spacing.xxl + "px",
        height: spacing_1.spacing.lg + "px",
        '&:hover': {
            cursor: 'pointer'
        }
    },
    track: {
        width: spacing_1.spacing.xxl + "px",
        height: spacing_1.spacing.lg + "px",
        borderRadius: spacing_1.spacing.md + "px",
        display: 'flex',
        justifyContent: 'space-between',
        alignitems: 'center',
        boxSizing: 'border-box',
        padding: '0px 8px 0px 8px'
    },
    selector: {
        width: '24px',
        height: '24px',
        borderRadius: '12px',
        position: 'absolute',
        margin: '4px',
        top: '0px'
    },
    text: {
        label: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '24px'
        },
        track: {
            display: 'flex',
            alignItems: 'center',
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '18px'
        }
    }
};
//# sourceMappingURL=global.styles.js.map